import { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { generateOptions, localized, maxTwoDecimals } from "../../../common/utils";
import Switch from "../../../common/Switch";

export function ContractGroup3( { state, dispatch }) {
  const { t } = useTranslation();

  const disabled = state.status === "COMPLETE";

  const [showMoreWorkTimeOptions, setShowMoreWorkTimeOptions] = useState(false);

  function SelectWorkCycle({ dispatch, workCycle }) {
    const [radioValue, setRadioValue] = useState(workCycle);

    const handleRadioChange = ({ target }) => {
      setRadioValue(target.value);
      dispatch({type:"workCycle", payload: target.value});
    };
    return ["radio"].map((type, idx) => (
      <div key={idx} className="mb-3">
        <Form.Check
          inline
          label={t("OneWeekPeriod", "Viikon jaksoissa")}
          name="workCycle"
          type={type}
          value="1"
          id={`inline-${type}-1`}
          onChange={handleRadioChange}
          checked={Number(radioValue) === 1}
        />
        <Form.Check
          inline
          label={t("TwoWeekPeriod", "Kahden viikon jaksoissa")}
          name="workCycle"
          type={type}
          value="2"
          id={`inline-${type}-2`}
          onChange={handleRadioChange}
          checked={Number(radioValue) === 2}
        />
        <Form.Check
          inline
          label={t("ThreeWeekPeriod", "Kolmen viikon jaksoissa")}
          name="workCycle"
          type={type}
          value="3"
          id={`inline-${type}-3`}
          onChange={handleRadioChange}
          checked={Number(radioValue) === 3}
        />
        <Form.Check
          inline
          label={t("YearPeriod", "Vuodessa")}
          name="workCycle"
          type={type}
          value="4"
          id={`inline-${type}-4`}
          onChange={handleRadioChange}
          checked={Number(radioValue) === 4}
        />
      </div>
    ));
  }

  return (
    <>
      <Row>
        <Form.Group as={Col} xl={4} className="position-relative" controlId="basis">
          <Form.Label>{t("Basis", "Palkan perusteet")}</Form.Label>
          <Form.Select disabled={disabled} value={state.pay.basis} onChange={(evt) => dispatch({type:"basis", payload: evt.target.value})}>
            <option value="0" disabled>{t("Choose", "Valitse")}</option>
            <option value="TIME">{t("Time", "Aika")}</option>
            <option value="ACHIEVEMENT">{t("Achievement", "Suoritus")}</option>
            <option value="OTHER">{t("OtherSpecify", "Muu, mikä")}</option>
          </Form.Select>
        </Form.Group>
        {state.pay.basis === "OTHER" &&
          <Form.Group as={Col} xl={4} className="position-relative" controlId="otherBasis">
            <Form.Label>{t("OtherBasis", "Muu peruste")}</Form.Label>
            <Form.Control disabled={disabled} value={state.pay.otherBasis ?? ""} onChange={(evt) => dispatch({type:"otherBasis", payload: evt.target.value})} />
          </Form.Group>
        }
        <Form.Group as={Col} xl={4} className="position-relative" controlId="employmentType">
          <Form.Label>{t("EmploymentType", "Palvelussuhteen tyyppi")}</Form.Label>
          <Form.Select disabled={disabled} value={state.pay.employmentType} onChange={(evt) => dispatch({type:"employmentType", payload: evt.target.value})}>
            {generateOptions(localized.employmentTypes)}
          </Form.Select>
        </Form.Group>
        {( Number(state.pay.employmentType) === 2 ) &&
          <Form.Group as={Col} xl={4} className="position-relative" controlId="partTimePercentage">
            <Form.Label>{t("PartTimePercentage", "Osa-aikaprosentti")}</Form.Label>
            <Form.Control type="number" min="0" step="0.01" pattern="^\d+(?:\.\d{1,2})?$" disabled={disabled} value={state.pay.partTimePercentage ?? ""} onChange={(evt) => dispatch({type:"partTimePercentage", payload: evt.target.value})} onBlur={(evt) => dispatch({type:"partTimePercentage", payload: maxTwoDecimals(evt.target.value)})}/>
          </Form.Group>
        }
      </Row>
      <Row>
        <Form.Group as={Col} xl={4} className="position-relative" controlId="formOfSalary">
          <Form.Label>{t("FormOfSalary", "Palkkausmuoto")}</Form.Label>
          <Form.Select disabled={disabled} value={state.pay.formOfSalary} onChange={(evt) => dispatch({type:"formOfSalary", payload: evt.target.value})}>
            {generateOptions(localized.salaryForms)}
          </Form.Select>
        </Form.Group>
        <Form.Group as={Col} xl={4} className="position-relative" controlId="amount">
          <Form.Label>{t("PayAmount", "Palkka")}</Form.Label>
          <Form.Control type="number" min="0" step="0.01" pattern="^\d+(?:\.\d{1,2})?$" disabled={disabled} value={state.pay.amount ?? ""} onChange={(evt) => dispatch({type:"amount", payload: evt.target.value})} onBlur={(evt) => dispatch({type:"amount", payload: maxTwoDecimals(evt.target.value)})} />
        </Form.Group>
        <Form.Group as={Col} xl={4} className="position-relative" controlId="currency">
          <Form.Label>{t("Currency", "Valuutta")}</Form.Label>
          <Form.Select disabled={disabled} value={state.pay.currency ?? "EUR"} onChange={(evt) => dispatch({type:"currency", payload: evt.target.value})}>
            <option value="EUR">EUR</option>
            <option value="SEK">SEK</option>
            <option value="USD">USD</option>
          </Form.Select>
        </Form.Group>
      </Row>

      <Row>
        {(Number(state.pay.formOfSalary) === 3 || state.pay.formOfSalary === null) && <>
          <Form.Group as={Col} xl={8} className="position-relative" controlId="payUnit">
            <Form.Label>{t("PayUnit", "Palkkayksikkö")}</Form.Label>
            <Form.Control disabled={disabled} value={state.pay.payUnit ?? ""} onChange={(evt) => dispatch({type:"payUnit", payload: evt.target.value})} />
          </Form.Group>
        </>}
      </Row>

      <Row>
        {(Number(state.pay.employmentType) === 2 && (Number(state.pay.formOfSalary) === 1 || state.pay.formOfSalary === null)) && <>
          <Form.Group as={Col} xl={4} className="position-relative" controlId="paymentPercentage">
            <Form.Label>{t("PaymentCoefficient", "Maksukerroin")} (%)</Form.Label>
            <Form.Control type="number" min="0" step="0.01" pattern="^\d+(?:\.\d{1,2})?$" disabled={disabled} value={state.pay.paymentPercentage ?? ""} onChange={(evt) => dispatch({type:"paymentPercentage", payload: evt.target.value})} onBlur={(evt) => dispatch({type:"paymentPercentage", payload: maxTwoDecimals(evt.target.value)})}/>
          </Form.Group>
          <Form.Group as={Col} xl={4} className="position-relative" controlId="paymentPercentageSalary">
            <Form.Label>{t("PaymentPercentageSalary", "Maksukertoimen mukainen palkka")}</Form.Label>
            <Form.Control type="number" min="0" step="0.01" pattern="^\d+(?:\.\d{1,2})?$" disabled={disabled} value={state.pay.paymentPercentageSalary ?? ""} onChange={(evt) => dispatch({type:"paymentPercentageSalary", payload: evt.target.value})} onBlur={(evt) => dispatch({type:"paymentPercentageSalary", payload: maxTwoDecimals(evt.target.value)})} />
          </Form.Group>
        </>}
      </Row>

      <Row>
        <Form.Group as={Col} xl={3} className="position-relative" controlId="phoneBenefit">
          <Form.Label></Form.Label>
          <Form.Check disabled={disabled} label={t("PhoneBenefit", "Puhelinetu")} id="phoneBenefit.toggle" checked={state.pay.phoneBenefit} onChange={() => dispatch({type: "phoneBenefit.toggle"})} />
          <Form.Label></Form.Label>
        </Form.Group>
        <Form.Group as={Col} xl={3} className="position-relative">
          <Form.Label></Form.Label>
          <Form.Check disabled={disabled} label={t("BicycleBenefit", "Polkupyöräetu")} id="bicycleBenefit.toggle" checked={state.pay.bicycleBenefit} onChange={() => dispatch({type: "bicycleBenefit.toggle"})} />
          { state.pay.bicycleBenefit &&
            <Switch disabled={disabled} label={t("SubtractsPayWage", "Vähentää rahapalkkaa")} id="bicycleBenefitSubstracts.toggle" checked={state.pay.bicycleBenefitSubstracts} onChange={() => dispatch({type: "bicycleBenefitSubstracts.toggle"})} />
          }
        </Form.Group>
        <Form.Group as={Col} xl={3} className="position-relative">
          <Form.Label></Form.Label>
          <Form.Check disabled={disabled} label={t("MealBenefit", "Ravintoetu")} id="mealBenefit.toggle" checked={state.pay.mealBenefit} onChange={() => dispatch({type: "mealBenefit.toggle"})} />
          { state.pay.mealBenefit &&
            <Switch disabled={disabled} label={t("MatchTaxValue", "Vastaa verotusarvoa")} id="mealBenefitTaxableValue.toggle" checked={state.pay.mealBenefitTaxableValue} onChange={() => dispatch({type: "mealBenefitTaxableValue.toggle"})} />
          }
        </Form.Group>
      </Row>

      <Row>
        <Form.Group as={Col} xl={4} className="position-relative" controlId="personalBenefit1">
          <Form.Label>{t("PersonalBenefit1", "Henk.koht luontoisetu")}</Form.Label>
          <Form.Select disabled={disabled} value={state.pay.personalBenefit1 ?? "0"} onChange={(evt) => dispatch({type:"personalBenefit1", payload: evt.target.value})}>
            {generateOptions(localized.personalBenefit).filter((v, idx) => idx !== 1)}
          </Form.Select>
        </Form.Group>
        <Form.Group as={Col} xl={4} className="position-relative" controlId="personalBenefit2">
          <Form.Label>{t("PersonalBenefit2", "Henk.koht luontoisetu 2")}</Form.Label>
          <Form.Select disabled={disabled} value={state.pay.personalBenefit2 ?? "0"} onChange={(evt) => dispatch({type:"personalBenefit2", payload: evt.target.value})}>
            {generateOptions(localized.personalBenefit)}
          </Form.Select>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} xl={4} className="position-relative" controlId="personalBenefitPlaceholder">
          <Form.Label></Form.Label>
        </Form.Group>
        {Number(state.pay.personalBenefit2) === 1 && <>
          <Form.Group as={Col} xl={2} className="position-relative" controlId="carUsageBenefit">
            <Form.Label></Form.Label>
            <Form.Check type="radio" disabled={disabled} name="carBenefit" label={t("LimitedCarBenefit", "Käyttöetu")} id="carUsageBenefit.toggle" checked={state.pay.carUsageBenefit} onChange={() => dispatch({type: "carUsageBenefit.toggle"})} />
            <Form.Label></Form.Label>
          </Form.Group>
          <Form.Group as={Col} xl={2} className="position-relative" controlId="freeCarBenefit">
            <Form.Label></Form.Label>
            <Form.Check type="radio" disabled={disabled} name="carBenefit" label={t("FullCarBenefit", "Vapaa autoetu")} id="freeCarBenefit.toggle" checked={state.pay.freeCarBenefit} onChange={() => dispatch({type: "freeCarBenefit.toggle"})} />
            <Form.Label></Form.Label>
          </Form.Group>
        </>}
      </Row>

      <Row>
        <Form.Group as={Col} xl={12} className="position-relative" controlId="otherBenefits">
          <Form.Label>{t("OtherBenefitsAndSalaryMatters", "Muut luontoisedut ja palkkaan liittyvät asiat")}</Form.Label>
          <Form.Control as="textarea" disabled={disabled} value={state.pay.otherBenefits ?? ""} onChange={(evt) => dispatch({type:"otherBenefits", payload: evt.target.value})} />
        </Form.Group>
      </Row>

      <Row>
        <Form.Group as={Col} xl={6} className="position-relative" controlId="period">
          <Form.Label>{t("PaymentPeriod", "Maksukausi")}</Form.Label>
          <Form.Control disabled={disabled} value={state.pay.period ?? ""} onChange={(evt) => dispatch({type:"period", payload: evt.target.value})} />
        </Form.Group>
        <Form.Group as={Col} xl={6} className="position-relative" controlId="day">
          <Form.Label>{t("Day", "Maksupäivä")}</Form.Label>
          <Form.Control disabled={disabled} value={state.pay.day ?? ""} onChange={(evt) => dispatch({type:"day", payload: evt.target.value})} />
        </Form.Group>
      </Row>

      <Row>
        <Form.Group as={Col} xl={3} className="position-relative" controlId="weeklyWorkHours">
          <Form.Label>{t("WeeklyWorkHours", "Viikkotyöaika")}</Form.Label>
          <Form.Control type="number" disabled={disabled} min="0" value={state.details.weeklyWorkHours ?? ""} onChange={(evt) => dispatch({type:"weeklyWorkHours", payload: evt.target.value})} />
        </Form.Group>
        <Form.Group as={Col} xl={3} className="position-relative mt-3" controlId="showMoreWorkTimeOptions">
          <Form.Check type="checkbox" disabled={disabled} label={t("ShowMoreWorkTimeOptions", "Näytä lisää työaikavaihtoehtoja")} checked={showMoreWorkTimeOptions} onChange={() => setShowMoreWorkTimeOptions(!showMoreWorkTimeOptions)} />
        </Form.Group>
      </Row>

      <Row>
        { (showMoreWorkTimeOptions || !!state.details.dailyWorkHours) &&
        <Form.Group as={Col} xl={3} className="position-relative" controlId="dailyWorkHours">
          <Form.Label>{t("DailyHours", "Vuorokautinen työaika")}</Form.Label>
          <Form.Control type="number" disabled={disabled} min="0" value={state.details.dailyWorkHours ?? ""} onChange={(evt) => dispatch({type:"dailyWorkHours", payload: evt.target.value})} />
        </Form.Group>
        }
      </Row>

      <Row>
        { (showMoreWorkTimeOptions || !!state.details.workHours) && <>
          <Form.Group as={Col} xl={3} className="position-relative" controlId="workHours">
            <Form.Label>{t("Hours", "Tuntia")}</Form.Label>
            <Form.Control type="number" disabled={disabled} min="0" value={state.details.workHours ?? ""} onChange={(evt) => dispatch({type:"workHours", payload: evt.target.value})} />
          </Form.Group>
          <Form.Group as={Col} xl={9} className="position-relative" controlId="workCycle">
            <Form.Label></Form.Label>
            <SelectWorkCycle dispatch={dispatch} workCycle={state.details.workCycle}/>
          </Form.Group>
        </>}
      </Row>

      <Row>
        <Form.Group as={Col} xl={12} className="position-relative" controlId="workHoursInformation">
          <Form.Label>{t("WorkHoursInformation", "Työajan lisätiedot")}</Form.Label>
          <Form.Control as="textarea" rows={3} disabled={disabled} value={state.details.workHoursInformation ?? ""} onChange={(evt) => dispatch({type:"workHoursInformation", payload: evt.target.value})} />
        </Form.Group>
      </Row>

      <Row>
        <Form.Group as={Col} xl={12} className="position-relative" controlId="vacationInformation">
          <Form.Label>{t("VacationInformation", "Vuosilomat")}</Form.Label>
          <Form.Control as="textarea" rows={3} disabled={disabled} value={state.details.vacationInformation ?? ""} onChange={(evt) => dispatch({type:"vacationInformation", payload: evt.target.value})} />
        </Form.Group>
      </Row>

    </>
  );
}
